import React, {lazy, Suspense} from 'react'

import type {DevToolsProps} from './DevTools.types'

const DevToolsComponent = lazy(() => import(/* webpackChunkName: "1337" */ './DevTools'))

export const DevTools: React.FC<DevToolsProps> = props =>
  props.config ? (
    <Suspense>
      <DevToolsComponent {...props} />
    </Suspense>
  ) : null
